import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App.jsx";
import { GithubProvider } from "./context/context";
import { Auth0Provider } from "@auth0/auth0-react";

//dev-w6q76epf.us.auth0.com
// PwAOaTtf8Efsg3sWdzNNbfHMctGTwp7W

ReactDOM.render(
	<React.StrictMode>
		<GithubProvider>
			<App />
		</GithubProvider>
	</React.StrictMode>,
	document.getElementById("root"),
);
